import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BackComponent } from '../../../../shared/components/back/back.component';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-terms-use',
  imports: [TranslateModule, BackComponent, RouterLink, NgClass],
  templateUrl: './terms-use.component.html',
})
export class TermsUseComponent {
  get lang() {
    return localStorage.getItem('lang');
  }

  get isRTL() {
    return this.lang === 'ar';
  }
}
